import React, { useEffect, useState } from "react";
import "../../styles/components/ToolBarLeftPanel.scss";
import DragIcon from "../../images/sixDotBlueBg.svg";
import Lock from "../../images/Locked1.svg";
import UnLock from "../../images/Unlocked1.svg";
import hideIcon from "../../images/Hide1.svg";
import { toast } from "react-toastify";
import EyeIcon from "../../images/Show1.svg";
import Tooltip from "@mui/material/Tooltip";
import hitAreaLinkIcon from "../../images/hitAreaLinkIcon.svg";
import {
  getConfiguredClickableAreaCount,
} from "../RightPanel/HitAreaModal/utils";
import "../../styles/components/AnimationTimeLine.scss";
import { useTranslation } from "react-i18next";
// import { DebounceInput } from "react-debounce-input";
import { arrayMove, SortableContainer, SortableElement } from "react-sortable-hoc";
// import Popover from "@mui/material/Popover";
// import Typography from "@mui/material/Typography";

import ButtonIcon from "../../images/ButtonNewIcon.svg";
import ContainerIcon from "../../images/container_icon.svg";
import ImageIcon from "../../images/image_icon.svg";
import Timage from "../../images/T.svg";

//import { toast } from "react-toastify";

const Item = SortableElement(
  ({
    item,
    selec,
    toggle,
    toggleInput,
    indexValue,
    handleTextChange,
    setToggle,
    updateLayerNameToDefault,
    layerName,
    toggleLockComp,
    toggleHideComp,
    setSelectedComponent,
    toggleAnimatedBanner,
    setMultiSelectedComps,
    layerCompData,
    items,
    handleCtrlClick,
  }) => {
    const { t } = useTranslation();
    const layerEntry = layerCompData?.find((entry) => entry.id === item.id);
    const componentStyles =
      layerEntry?.componentStyles ?? item?.componentStyles ?? {};
    const clickableAreaCount =
      item?.componentType === "Image"
        ? getConfiguredClickableAreaCount(componentStyles?.hitAreas)
        : 0;
    const hasClickableAreasConfigured = clickableAreaCount > 0;
    const clickableAreasTooltipText = t("timelineMenu.clickableAreasConfigured", {
      count: clickableAreaCount,
    });
    const isSelectedLayer = item.id === selec?.id;
    const resolvedLayerName = item?.componentStyles?.layerName || "";
    const showLayerNameTooltip = resolvedLayerName.length > 10;
    const wrapLayerNameTooltip = (nameElement) =>
      showLayerNameTooltip ? (
        <Tooltip title={resolvedLayerName} placement="top">
          {nameElement}
        </Tooltip>
      ) : (
        nameElement
      );

    return (
      <>
        <div
          //  className="SortableItem"
          onClick={(e) => {
            setSelectedComponent(item);
            handleCtrlClick(e, item);
          }}
          key={item.id}
          className={`layers row ${
            (item.id === selec?.id || item.multiSelected) &&
            "addHeadingSelected"
          }`}
        >
          <div className="layer-dragImage1 col-md-1">
            {isSelectedLayer && (
              <img
                src={DragIcon}
                alt="drag"
                draggable={false}
                className="img-fluid1 dragIcon"
              />
            )}
          </div>
          <div className="layer-textImage2 col-md-3">
            <img
              src={
                item.componentType === "Text"
                  ? Timage
                  : item.componentType === "Button"
                    ? ButtonIcon
                    : item.componentType === "Image"
                      ? ImageIcon
                      : ContainerIcon
              }
              alt="heading"
              draggable={false}
              className="img-fluid1 iconSize"
            />

            {/* <div className="layer-headline1 col-5"></div> */}
          </div>
          <div className="text-icon1 col-md-4">
            {toggle
              ? wrapLayerNameTooltip(
                  <div
                    className="ellipseHidden"
                    onDoubleClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      toggleInput(item.id);
                    }}
                  >
                    {resolvedLayerName ? (
                      resolvedLayerName
                    ) : (
                      <span>{"Enter layer name"}</span>
                    )}
                  </div>
                )
              : indexValue === item?.id ? (
                <input
                  className="inputElem"
                  // element="input"
                  // debounceTimeout={500}
                  style={{ width: "75px" }}
                  type="text"
                  value={layerName}
                  onChange={(e) => {
                    handleTextChange(e, item.id);
                  }}
                  onBlur={(e) => {
                    setToggle(true);
                    updateLayerNameToDefault(e);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setToggle(true);
                      updateLayerNameToDefault(e);
                    }
                  }}
                  autoFocus
                />
              ) : (
                wrapLayerNameTooltip(
                  <div
                    className="ellipseHidden"
                    onDoubleClick={() => {
                      toggleInput(item.id);
                    }}
                  >
                    {resolvedLayerName}
                  </div>
                )
              )}
            {item?.componentType === "Image" &&
              hasClickableAreasConfigured && (
                <Tooltip
                  title={clickableAreasTooltipText}
                  placement="top"
                  arrow
                  classes={{
                    popper: "clickableAreasTooltip",
                    tooltip: "clickableAreasTooltip",
                  }}
                >
                  <span
                    className={
                      isSelectedLayer
                        ? "linkIndicatorWrap"
                        : "d-none !important"
                    }
                    onClick={(e) => e.stopPropagation()}
                    aria-label={clickableAreasTooltipText}
                  >
                    <img
                      src={hitAreaLinkIcon}
                      alt=""
                      draggable={false}
                      className="linkIndicatorSize"
                    />
                  </span>
                </Tooltip>
              )}
          </div>

          <div className="lock-icon1 col-md-1 lockIconSize">
            <Tooltip
              title={
                item?.componentStyles?.lockBoolean === false
                  ? "Lock Layer "
                  : "UnLock Layer"
              }
              placement="top"
            >
              <img
                src={
                  item?.componentStyles?.lockBoolean === false ? UnLock : Lock
                }
                alt="LockIcon"
                className={
                  item.id === selec?.id
                    ? " img-fluid1 iconSize"
                    : " d-none !important"
                }
                onClick={(e) => {
                  e.stopPropagation();
                  item.id === selec?.id && toggleLockComp(item);
                }}

                // draggable={false}
              />
            </Tooltip>
          </div>

          <div className="eye-icon1 col-md-1">
            <Tooltip
              title={
                item?.componentStyles?.hideBoolean === false
                  ? "Hide Layer "
                  : "Show Layer"
              }
              placement="top"
            >
              <img
                src={
                  item?.componentStyles?.hideBoolean === false
                    ? EyeIcon
                    : hideIcon
                }
                alt="heading"
                className={
                  item.id === selec?.id
                    ? "img-fluid1 eyeIconSize"
                    : "d-none !important"
                }
                onClick={(e) => {
                  e.stopPropagation();
                  item.id === selec?.id && toggleHideComp(item);
                }}
                // draggable={false}
              />
            </Tooltip>
          </div>
        </div>
      </>
    );
  },
);

const ItemContainer = SortableContainer(
  ({
    items,
    selec,
    toggle,
    toggleInput,
    indexValue,
    handleTextChange,
    setToggle,
    updateLayerNameToDefault,
    layerName,
    toggleHideComp,
    toggleLockComp,
    setSelectedComponent,
    toggleAnimatedBanner,
    setMultiSelectedComps,
    multiSelectedComps,
    setLayerCompData,
    layerCompData,
    handleCtrlClick,
  }) => (
    <div>
      {items.map((item, index) => {
        return (
          <Item
            items={items}
            className="SortableList"
            key={`item-${item.id}`}
            item={item}
            index={index}
            selec={{ ...selec }}
            toggle={toggle}
            toggleInput={toggleInput}
            indexValue={indexValue}
            handleTextChange={handleTextChange}
            setToggle={setToggle}
            updateLayerNameToDefault={updateLayerNameToDefault}
            layerName={layerName}
            toggleHideComp={toggleHideComp}
            toggleLockComp={toggleLockComp}
            setSelectedComponent={setSelectedComponent}
            toggleAnimatedBanner={toggleAnimatedBanner}
            setMultiSelectedComps={setMultiSelectedComps}
            multiSelectedComps={multiSelectedComps}
            setLayerCompData={setLayerCompData}
            layerCompData={layerCompData}
            handleCtrlClick={handleCtrlClick}
          />
        );
      })}
    </div>
  ),
);

export default function ElementLayers({
  layerCompData,
  selectedComponent,
  setSelectedComponent,
  setLayerCompData,
  toggleLockComp,
  toggleHideComp,
  toggleAnimatedBanner,
  playPause,
  setMultiSelectedComps,
  handleCtrlClick,
}) {
  const [toggle, setToggle] = useState(true);
  const [indexValue, setIndexValue] = useState(undefined);
  const chartCount = 13; //To Show layer tooltip only when it exceeds 13 characters

  const { t } = useTranslation();
  const toggleInput = (index) => {
    setToggle(false);
    setIndexValue(index);
    setLayerName(selectedComponent.componentStyles.layerName);
  };
  const handleTextChange = (e, id) => {
    const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    if (specialChars.test(e.target.value)) return;

    setLayerName(e.target.value);

    // console.log(id, "id");
    // let tempSelected = [...layerCompData];

    // let x = tempSelected.findIndex((selComp) => selComp.id === id);
    // tempSelected[x].componentStyles.layerName = e.target.value;
    // setLayerCompData(tempSelected);

    // let tempSelected = { ...selectedComponent };

    // tempSelected.componentStyles.layerName = e.target.value;

    // setSelectedComponent(tempSelected);
  };
  const updateLayerNameToDefault = (e) => {
    let tempSelected = { ...selectedComponent };
    if (layerName === "" || layerName?.trim() === "") {
      tempSelected.componentStyles.layerName = selectedComponent.componentStyles
        .layerNameSaved
        ? selectedComponent.componentStyles.layerNameSaved
        : selectedComponent.componentStyles.layerNameUpdated;
      setLayerName(tempSelected.componentStyles.layerName);
    } else if (e.target.value.length > 200) {
      toast.error(
        <div className="notificationText">
          {t("Layer name can not be more than 200 characters")}
        </div>,
      );
      setLayerName(tempSelected.componentStyles.layerName);
    } else {
      tempSelected.componentStyles.layerName = e.target.value;
    }
    setSelectedComponent(tempSelected);
  };
  const [layerName, setLayerName] = useState(
    selectedComponent?.componentStyles?.layerName,
  );

  const onReorder = ({ oldIndex, newIndex }) => {
    let swappedLayerCompData = arrayMove(layerCompData, oldIndex, newIndex);

    swappedLayerCompData.forEach((layerObj, index) => {
      swappedLayerCompData[index].componentStyles.zIndex =
        swappedLayerCompData.length - index;
    });
    setLayerCompData(swappedLayerCompData);
  };

  return (
    <div
      className="list-layers custonVertScrollBar"
      id="leftDiv"
      // style={{
      //   height: "189px",
      //   overflowY: "scroll",
      // }}
      style={{
        overflowY: "scroll",
        overflowX: "hidden",
        cursor: !playPause.animationCompleted ? "default" : undefined,
      }}
    >
      <div
        className="element-name"
        style={{
          pointerEvents: !playPause.animationCompleted ? "none" : undefined,
          cursor: !playPause.animationCompleted ? "default" : undefined,
        }}
      >
        <ItemContainer
          items={layerCompData}
          onSortEnd={onReorder}
          distance={1}
          selec={{ ...selectedComponent }}
          toggle={toggle}
          toggleInput={toggleInput}
          indexValue={indexValue}
          handleTextChange={handleTextChange}
          setToggle={setToggle}
          updateLayerNameToDefault={updateLayerNameToDefault}
          layerName={layerName}
          toggleHideComp={toggleHideComp}
          toggleLockComp={toggleLockComp}
          setSelectedComponent={setSelectedComponent}
          toggleAnimatedBanner={toggleAnimatedBanner}
          setMultiSelectedComps={setMultiSelectedComps}
          layerCompData={layerCompData}
          handleCtrlClick={handleCtrlClick}
        />
      </div>
    </div>
  );
}
